var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import isEqual from 'lodash.isequal';
var BaseModule = /** @class */ (function () {
    function BaseModule(adapter, option) {
        this.adapter = adapter;
        this.option = option;
    }
    BaseModule.prototype.setProps = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
    };
    BaseModule.prototype.replaceProps = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
    };
    BaseModule.prototype.destructor = function () { };
    return BaseModule;
}());
var ModuleManager = /** @class */ (function () {
    function ModuleManager(adapter, modulesMap) {
        this.modulesMap = {};
        this.cache = {};
        this.adapter = adapter;
        this.modulesMap = __assign({}, modulesMap);
    }
    ModuleManager.prototype.install = function () {
        var _this = this;
        Object.keys(this.modulesMap).forEach(function (name) {
            var moduleMap = _this.modulesMap[name];
            _this.cache[name] = new moduleMap.Ctor(_this.adapter, moduleMap.option);
        });
    };
    ModuleManager.prototype.get = function (name) {
        return this.cache[name];
    };
    ModuleManager.prototype.update = function (props) {
        var _this = this;
        Object.keys(props).map(function (name) { return _this.updateModule(name, props[name].option); });
    };
    ModuleManager.prototype.updateModule = function (name, option) {
        var instance = this.cache[name];
        var curConfig = this.modulesMap[name];
        if (!instance || !curConfig)
            return false;
        if (!isEqual(curConfig.option, option)) {
            instance.setProps(option);
            curConfig.option = __assign(__assign({}, curConfig.option), option);
        }
    };
    ModuleManager.prototype.add = function (name, override) {
        if (override === void 0) { override = false; }
        if (!override && this.cache[name])
            return;
        var moduleMap = this.modulesMap[name];
        if (!moduleMap)
            return;
        var module = this.cache[name];
        if (module) {
            module.destructor();
            this.cache[name] = null;
        }
        this.cache[name] = new moduleMap.Ctor(this.adapter, moduleMap.option);
    };
    ModuleManager.prototype.remove = function (name) {
        var module = this.cache[name];
        if (module) {
            module.destructor();
            this.cache[name] = null;
        }
    };
    ModuleManager.prototype.uninstall = function () {
        var _this = this;
        Object.keys(this.cache).forEach(function (name) {
            var module = _this.cache[name];
            module && module.destructor();
            _this.cache[name] = null;
        });
    };
    return ModuleManager;
}());
export { BaseModule, ModuleManager };
//# sourceMappingURL=module.js.map